import isEmpty from 'lodash/isEmpty';

const runnerModel = {
    state: {
        depth: {
            relative: 0,
            absolute: 0,
        },
        runnerValue: null,
        runnerTooltipMode: '',
        runnerValues: {},

        isActiveRunner: true,
        viewMode: false,
        tipMode: 'DEPTH',
        tooltipInfoData: null,
    },
    reducers: {
        setDepth: (state, payload) => {
            return {
                ...state,
                depth: payload,
            };
        },
        setRunnerValue(state, payload) {
            return { ...state, runnerValue: payload };
        },
        setRunnerTooltipMode(state, payload) {
            return { ...state, runnerTooltipMode: payload };
        },

        setT(state, p) {
            // payload : {value: number | string, type: relative | absolute}
            //формула для рассчета подскорлливания
            // Math.abs((depth?.min - runnerValue) * scale)
            const result = Math.abs((p.min - p.value) * p.scale);
            return { ...state, runnerValue: { relative: result } };
        },
        initTabletInfo(state, payload) {
            return { ...state, runnerValues: { ...state.runnerValues, [payload.id]: payload } };
        },

        reset(state) {
            return { ...state, runnerValue: null };
        },

        setIsActiveRunner(state, payload) {
            return { ...state, isActiveRunner: payload };
        },
        setTipMode(state, payload) {
            return { ...state, tipMode: payload };
        },
        setViewMode(state, { visible }) {
            return { ...state, viewMode: visible };
        },
        setTooltipInfoData(state, payload) {
            return { ...state, tooltipInfoData: payload };
        },
    },
    effects: {
        setTest(payload, rootState) {
            const { scale, list, activeGroupName } = rootState.tablets;
            const well = list[activeGroupName][62];

            this.setT({ min: well.depthRange.min, scale, value: payload });
        },
        setTooltipInfoDataEffect(payload, rootState) {
            const { filteredCurveData } = rootState.inspector;
            const { tipMode } = rootState.runner;
            const selectedCurves = rootState.tabletObjectsModel.multiObject;

            let data;

            if (tipMode === 'CURVES') {
                // передаем данные в зависимости от того, есть ли активные кривые в планшете
                data = isEmpty(selectedCurves)
                    ? filteredCurveData
                    : selectedCurves.ids.map(i => filteredCurveData.filter(it => it.code === i)).flat(2);
            }

            this.setTooltipInfoData(data);
        },
        /*
            * Этот эффект нужен для того, чтобы управлять видимостью "бегунка" снаружи из других моделей.
            Например, при активации режима рисования интервала на планшете - нужно отключать бегунок.
        */
        setViewModeEffect(payload) {
            this.setViewMode(payload);
        }
    },
};

export default runnerModel;
